<template>
  <v-img
    height="200px"
    :src="srcImage"
    contain
    v-if="!isError"
    @error="isError = true"
  >
  </v-img>
  <v-img src="/img/media.jpg" height="200px" cover v-else> </v-img>
</template>

<script>
export default {
  name: 'ImageContainer',
  props: {
    srcImage: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isError: false
    };
  }
};
</script>
